<template>
  <div></div>
</template>

<script>
import axios from 'axios'
import {url} from "@/configs/apiUrl";

export default {
  data() {
    return {

    }
  },
  methods: {
    openLoading() {
      this.$vs.loading({
          type: "default"
      });
    },
  },
  mounted() {
    this.openLoading()

    this.$store.dispatch('createAuditTrail', {
      user_id:    JSON.parse(localStorage.getItem('userInfo')).id,
      session_id: parseInt(localStorage.getItem('sessID')),
      user_name:  JSON.parse(localStorage.getItem('userInfo')).displayName,
      menu:      "Logout",
    })

    axios.get(url.svd.auth.logout, {headers : {'Authorization' : `Bearer ${JSON.parse(localStorage.getItem('userInfo')).access_token.token}`}}).then(resp => {
      this.$vs.loading.close();
      if(resp.data.message_code == "2002"){
        this.$acl.change("all");
        localStorage.clear();
        this.$router.push("/login");
      } else {
        this.danger("Ooops..", "Error occured while logging you out, please try again later")
      }
    }).catch(e => {
       this.$vs.loading.close();
      console.log("Error while logging out")
      console.log(e)
      this.danger("Ooops..", "Error occured while logging out, please try again later")
    })
  }
}
</script>